export default __webpack_public_path__ + "static/media/Bell_B.3cad97c6.svg";